import { render, staticRenderFns } from "./valuestreammetrics.vue?vue&type=template&id=098308ca"
import script from "./valuestreammetrics.vue?vue&type=script&lang=js"
export * from "./valuestreammetrics.vue?vue&type=script&lang=js"
import style0 from "./valuestreammetrics.vue?vue&type=style&index=0&id=098308ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports